<div
  class="lib-card"
  [class.padding-none]="padding === 'none'"
  [class.padding-sm]="padding === 'sm'"
  [class.padding-md]="padding === 'md'"
  [class.padding-lg]="padding === 'lg'"
  [class.shadow-none]="shadow === 'none'"
  [class.shadow-sm]="shadow === 'sm'"
  [class.shadow-md]="shadow === 'md'"
  [class.shadow-lg]="shadow === 'lg'"
  [class.bordered]="bordered"
  [class.hoverable]="hoverable"
>
  <ng-content></ng-content>
</div>

